import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  font-size: 0;

  display: flex;
  align-items: center;
`

interface IButtonProps {
  openSelector: boolean
}

export const Button = styled.span<IButtonProps>`
  border: none;
  background: transparent;
  cursor: pointer;
  margin-left: 5px;
  transition: 0.3s;

  svg {
    transform: ${props => (props.openSelector ? 'rotate(180deg)' : '')};
    fill: ${props => props.theme.colors.color545e6c};
    font-size: 10px;
    width: 12px;
  }
`

interface ISelection {
  show: boolean
}

export const Selection = styled.div<ISelection>`
  position: absolute;
  width: 200px;
  padding: 10px 8px;
  bottom: 0;
  left: 50%;

  display: ${props => (props.show ? 'block' : 'none')};
  transform: translate(-50%, 115%);

  background: ${({ theme }) => theme.zds.colors.neutral1000};
  box-shadow: 0px 4px 4px ${props => props.theme.colors.colorBlack29};
  border-radius: 0px 0px 4px 4px;
  z-index: 99;
  cursor: pointer;

  ul {
    li + li {
      margin-top: 20px;
    }

    li {
      width: 100%;
      display: flex;

      flex-direction: row;
      align-items: center;

      span {
        margin-left: 10px;
      }
    }
  }
`
